import { Lock } from "lucide-react";

// Small circular "locked" indicator — matches the lock badge already used on
// premium app themes in the Settings panel's theme picker (a translucent
// dark circle with a white lock icon), reused everywhere else a feature just
// needs to show it's locked without being tappable.
export function LockBadge({ size = 20, iconSize }) {
  const icon = iconSize || Math.round(size * 0.55);
  return (
    <span style={{
      width: size, height: size, borderRadius: "50%", flexShrink: 0,
      background: "rgba(0,0,0,0.45)",
      display: "inline-flex", alignItems: "center", justifyContent: "center",
    }}>
      <Lock size={icon} color="#ffffff" strokeWidth={2.5} />
    </span>
  );
}
